import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';

const drawForm = {
  fields: {
    firstName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The first name field is required.',
    },
    lastName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The last name field is required.',
    },
    phoneNumber: {
      value: '',
      error: null,
      rule: 'required|regex:/^\\d{3}-?\\d{3}-?\\d{4}$/|alpha_dash',
      message: 'Phone must be a number with the format xxx-xxx-xxxx',
    },
    email: {
      value: '',
      error: null,
      rule: 'required|email',
      message: 'The email address is required.',
    },
    comments: {
      value: '',
      error: null,
      rule: '',
    },
    drawType: {
      value: 'regular',
      error: null,
      rule: 'required',
    },
    propertyId: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The property field is required.',
    },
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    showErrors: null,
    error: null,
  },
}

export class AddDrawFormStore extends FormStore {
  private globalStore: GlobalStore;
  constructor(globalStore) {
    super({ ...drawForm }, globalStore);
    this.globalStore = globalStore;
  }
}